import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import { CustomCard } from '../../../../../components/CustomCard';
import CustomCheckbox from '../../../../../components/CustomCheckbox/CustomCheckbox';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { PROJECT_STATUS_PENDENTE } from '../../../../../library/ProjectStatus';
import { loadAssessoresByCoop } from '../../../../../store/modules/AssessoresActions';
import {
  loadEscolas,
  loadEtapasEnsino,
  loadPrincipiosValores,
} from '../../../../../store/modules/EscolasActions';
import { loadCooperativas } from '../../../../../store/modules/LogradouroActions';
import { loadEducadores } from '../../../../../store/modules/ProfessoresActions';
import {
  alterarCheckCoordenador,
  alterarCheckProfGestor,
  changeProjetoValue,
  saveProjeto,
} from '../../../../../store/modules/ProjetoActions';
import { putMaskIntoValue } from '../../../../../utils/DataUtils';
import { getRenderedSelectMultipleValues } from '../../../../../utils/SelectUtils';
import { Col } from './../../../../../components/Col';
import { Row } from './../../../../../components/Row';
import styles from './Etapa9.scss';
import StepRow from './etapa9/StepRow';
const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  etapa0Extended: true,
  etapa1Extended: true,
  etapa2Extended: true,
  etapa3Extended: true,
  etapa4Extended: true,
  etapa5Extended: true,
  etapa6Extended: true,
  etapa7Extended: true,
  etapa8Extended: true,
  loading: true,
  checkChangedCoordenador: false,
  checkChangedProfGestor: false,
};

class Etapa9 extends GenericProjectCard {
  stepIndex = 10;

  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;

    this.onChangedExtendedByIndex = this.onChangedExtendedByIndex.bind(this);
  }

  onChangedExtendedByIndex(index, extended) {
    this.setState({
      ...this.state,
      ['etapa' + index + 'Extended']: extended,
    });
  }

  getStepClassNames(stepIndex) {
    return rootClassName + ' ' + rootClassName + '-etapa-' + stepIndex;
  }

  hasModeratorPermission() {
    return Boolean(
      this.props.auth.userPermissions.projetos.approve ||
        this.props.auth.userPermissions.projetos.reprove
    );
  }

  refreshAccordionState() {
    let newState = {
      loading: false,
    };

    this.props.projeto.avaliacoes.map((avaliacao, index) => {
      if (this.hasModeratorPermission()) {
        newState['etapa' + index + 'Extended'] =
          avaliacao.status === PROJECT_STATUS_PENDENTE ? true : false;
      } else {
        newState['etapa' + index + 'Extended'] = true;
      }
      return index;
    });

    this.setState({
      ...this.state,
      ...newState,
    });
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (!newProps.loading && this.state.loading) {
      this.refreshAccordionState();
      this.loadAll();
    }
  }

  loadProfessores(idEscola) {
    this.props.loadEducadores(
      idEscola,
      this.props.projeto.codigoCooperativa,
      this.props.projeto.cpfsProfessores,
      null,
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadEducadores,
          options: {
            variant: 'error',
          },
        });
      }
    );
  }

  getAssessores() {
    if (
      typeof this.props.projeto.codigoCooperativa === 'string' &&
      this.props.projeto.codigoCooperativa.length > 0
    ) {
      return this.props.assessores.listByCoop || [];
    }
    return [];
  }

  UNSAFE_componentWillMount() {
    this.loadAll();
  }

  loadAll() {
    let data = [];
    data.push(this.props.projeto.idEscola);
    this.props.loadEscolas(
      data,
      () => {
        this.loadProfessores(this.props.projeto.idEscola);
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadEscolas,
          options: {
            variant: 'error',
          },
        });
      }
    );

    if (this.props.projeto.codigoCooperativa.length > 0) {
      this.props.loadCooperativas(false, [
        this.props.projeto.codigoCooperativa,
      ]);
      this.props.loadAssessoresByCoop(
        this.props.projeto.codigoCooperativa,
        this.props.projeto.cpfsAssessores,
        false,
        null,
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorLoadAssessores,
            options: {
              variant: 'error',
            },
          });
        }
      );
    } else {
      this.props.loadCooperativas();
    }

    this.props.loadEtapasEnsino();

    this.props.loadPrincipiosValores();

    if (!this.props.loading && this.state.loading) {
      this.refreshAccordionState();
    }
  }

  alterarCheckCoordenador = (event) => {
    if (event.target.value) {
      this.props.alterarCheckCoordenador(
        this.props.projeto.id,
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.projetoChecked,
            options: {
              variant: 'success',
            },
          });
        },
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.erroProjetoCheckedCoordenador,
            options: {
              variant: 'error',
            },
          });
        }
      );
    } else {
      this.props.alterarCheckCoordenador(
        this.props.projeto.id,
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.projetoRemoveChecked,
            options: {
              variant: 'success',
            },
          });
        },
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.erroProjetoCheckedCoordenador,
            options: {
              variant: 'error',
            },
          });
        }
      );
    }
    this.refreshAccordionState();
    this.setValue(event);
  };

  alterarCheckProfGestor = (event) => {
    if (event.target.value) {
      this.props.alterarCheckProfGestor(
        this.props.projeto.id,
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.projetoChecked,
            options: {
              variant: 'success',
            },
          });
        },
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.erroProjetoCheckedProf,
            options: {
              variant: 'error',
            },
          });
        }
      );
    } else {
      this.props.alterarCheckProfGestor(
        this.props.projeto.id,
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.projetoRemoveChecked,
            options: {
              variant: 'success',
            },
          });
        },
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.projetoRemoveChecked,
            options: {
              variant: 'error',
            },
          });
        }
      );
    }
    this.refreshAccordionState();
    this.setValue(event);
  };

  componentWillUnmount() {
    this.setState(INITIAL_STATE);
  }

  render() {
    return (
      <CustomCard
        stepIndex={
          this.props.auth.userPermissions.projetos.register ||
          this.props.auth.userPermissions.projetos.edit
            ? this.stepIndex
            : null
        }
        CardHeaderPropTypes={{
          title: this.props.languageValues.etapa9,
        }}
        saving={this.state.loading}
      >
        <Row className='form-row'>
          <Col
            cols={[4, 4, 4, 4, 4]}
            className={rootClassName + '-checkbox-col-with-help-button'}
          >
            {this.props.auth.userPermissions.projetos.viewChecker
              .professorGestor ? (
              <CustomCheckbox
                name='checkProfGestor'
                label={this.props.languageValues.labelCheckProfessorGestor}
                onChange={(evento) => {
                  this.alterarCheckProfGestor(evento);
                }}
                checked={this.props.projeto.checkProfGestor}
              />
            ) : null}
            {this.props.auth.userPermissions.projetos.viewChecker
              .coordenadorLocal ? (
              <CustomCheckbox
                name='checkCoordenador'
                label={this.props.languageValues.labelCheckCoordenador}
                onChange={(event) => {
                  this.alterarCheckCoordenador(event);
                }}
                checked={this.props.projeto.checkCoordenador}
              />
            ) : null}
          </Col>
        </Row>
        {this.state.loading ? (
          <p>{this.props.languageValues.refreshingProject}</p>
        ) : (
          <div className={rootClassName + '-container'}>
            <StepRow
              stepIndex={0}
              lockedAllFields={this.props.lockedAllFields}
              onExtendChanged={this.onChangedExtendedByIndex}
              fieldNames={[
                this.props.languageValues.escola,
                this.props.languageValues.assessoresPedagogicos,
                this.props.languageValues.preTitulo,
                this.props.languageValues.educadores,
                this.props.languageValues.etapaDeEnsino,
                this.props.languageValues.turma,
                this.props.languageValues.quantidadeDeAlunos,
                this.props.languageValues.cooperativa,
                this.props.languageValues.periodoInicial,
                this.props.projeto.periodoFinal !== ''
                  ? this.props.languageValues.periodoFinal
                  : null,
                this.props.languageValues.direitoImagem,
              ]}
              fieldValues={[
                this.props.escolas.loadingList
                  ? this.props.languageValues.carregandoEscolas
                  : getRenderedSelectMultipleValues(
                      [this.props.projeto.idEscola],
                      this.props.escolas.list,
                      'id',
                      'nome'
                    ),
                this.props.assessores.loadingListByCoop
                  ? this.props.languageValues.carregandoAssessores
                  : getRenderedSelectMultipleValues(
                      this.props.projeto.cpfsAssessores,
                      this.getAssessores(),
                      'cpf',
                      'nome'
                    ),
                this.props.projeto.nome,
                this.props.professores.loadingEducadoresList
                  ? this.props.languageValues.carregandoEducadores
                  : getRenderedSelectMultipleValues(
                      this.props.projeto.cpfsProfessores,
                      this.props.professores.educadoresList,
                      'cpf',
                      'nome'
                    ),
                this.props.escolas.loadingEtapasEnsinoList
                  ? this.props.languageValues.loadingEtapasEnsinoList
                  : getRenderedSelectMultipleValues(
                      this.props.projeto.idEtapasEnsino,
                      this.props.escolas.etapasEnsinoList,
                      'id',
                      'nome'
                    ),
                this.props.projeto.descricaoTurma,
                this.props.projeto.quantidadeAlunosTurma,
                this.props.logradouro.loadingCooperativas
                  ? this.props.languageValues.loadingCooperativas
                  : getRenderedSelectMultipleValues(
                      [this.props.projeto.codigoCooperativa],
                      this.props.allCooperativas,
                      'codigo',
                      'nome'
                    ),
                this.props.projeto.periodoInicial !== ''
                  ? putMaskIntoValue(this.props.projeto.periodoInicial)
                  : null,
                this.props.projeto.periodoFinal !== ''
                  ? putMaskIntoValue(this.props.projeto.periodoFinal)
                  : null,
                this.props.projeto.direitoImagem ? 'Sim' : 'Não',
              ]}
              extended={this.state['etapa' + 0 + 'Extended']}
            />

            <StepRow
              stepIndex={1}
              lockedAllFields={this.props.lockedAllFields}
              onExtendChanged={this.onChangedExtendedByIndex}
              fieldNames={[
                this.props.languageValues.justificativa,
                this.props.languageValues.cienciaCoordenador,
              ]}
              fieldValues={[
                this.props.projeto.justificativa,
                this.props.projeto.avaliacoes[1]
                  ? this.props.projeto.cienciaCordenador
                    ? 'Sim'
                    : 'Não'
                  : null,
              ]}
              extended={this.state['etapa' + 1 + 'Extended']}
            />

            <StepRow
              stepIndex={2}
              lockedAllFields={this.props.lockedAllFields}
              onExtendChanged={this.onChangedExtendedByIndex}
              fieldNames={[
                this.props.languageValues.descricaoPerguntaExploratoria,
                this.props.languageValues.descricaoTerritorioInvestigado,
                this.props.languageValues.descricaoObjetivoExpedicao,
              ]}
              fieldValues={[
                this.props.projeto.descricaoPerguntaExploratoria,
                this.props.projeto.descricaoTerritorioInvestigado,
                this.props.projeto.descricaoObjetivoExpedicao,
              ]}
              extended={this.state['etapa' + 2 + 'Extended']}
            />

            <StepRow
              stepIndex={3}
              lockedAllFields={this.props.lockedAllFields}
              onExtendChanged={this.onChangedExtendedByIndex}
              fieldNames={[this.props.languageValues.descricaoExpedicao]}
              fieldValues={[this.props.projeto.descricaoExpedicao]}
              extended={this.state['etapa' + 3 + 'Extended']}
            />

            <StepRow
              stepIndex={4}
              lockedAllFields={this.props.lockedAllFields}
              onExtendChanged={this.onChangedExtendedByIndex}
              fieldNames={[
                this.props.languageValues.descricaoPerguntas,
                this.props.languageValues.tituloProjeto,
              ]}
              fieldValues={[
                this.props.projeto.descricaoPerguntas,
                this.props.projeto.nome,
              ]}
              extended={this.state['etapa' + 4 + 'Extended']}
            />

            <StepRow
              stepIndex={5}
              lockedAllFields={this.props.lockedAllFields}
              onExtendChanged={this.onChangedExtendedByIndex}
              fieldNames={[
                this.props.languageValues.descricaoIndiceInicial,
                this.props.languageValues.descricaoIndiceFormativo,
              ]}
              fieldValues={[
                this.props.projeto.descricaoIndiceInicial,
                this.props.projeto.descricaoIndiceFormativo,
              ]}
              extended={this.state['etapa' + 5 + 'Extended']}
            />

            <StepRow
              stepIndex={6}
              lockedAllFields={this.props.lockedAllFields}
              onExtendChanged={this.onChangedExtendedByIndex}
              fieldNames={[
                this.props.languageValues.descricaoComponenteCurricular,
                this.props.languageValues.descricaoAtividadeDesenvolvida,
                this.props.languageValues.idPrincipiosValores,
                this.props.languageValues.descricaoPrincipioValor,
              ]}
              fieldValues={[
                this.props.projeto.descricaoComponenteCurricular,
                this.props.projeto.descricaoAtividadeDesenvolvida,
                this.props.projeto.idPrincipiosValores.length === 0
                  ? ''
                  : getRenderedSelectMultipleValues(
                      this.props.projeto.idPrincipiosValores,
                      this.props.escolas.principioValorList,
                      'id',
                      'nome'
                    ) || this.props.languageValues.carregandoPrinciposValores,
                this.props.projeto.descricaoPrincipioValor,
              ]}
              extended={this.state['etapa' + 6 + 'Extended']}
            />

            <StepRow
              stepIndex={7}
              lockedAllFields={this.props.lockedAllFields}
              onExtendChanged={this.onChangedExtendedByIndex}
              fieldNames={[
                this.props.languageValues.descricaoComunidadeAprendizagem,
                this.props.languageValues.apoiadores,
              ]}
              fieldValues={[
                this.props.projeto.descricaoComunidadeAprendizagem,
                this.props.projeto.apoiadores,
              ]}
              extended={this.state['etapa' + 7 + 'Extended']}
            />

            <StepRow
              stepIndex={8}
              lockedAllFields={this.props.lockedAllFields}
              onExtendChanged={this.onChangedExtendedByIndex}
              fieldNames={[
                this.props.languageValues.descricaoAtividadeIntegradora,
                this.props.languageValues.descricaoIndiceFinal,
              ]}
              fieldValues={[
                this.props.projeto.descricaoAtividadeIntegradora,
                this.props.projeto.descricaoIndiceFinal,
              ]}
              extended={this.state['etapa' + 8 + 'Extended']}
            />

            <StepRow
              stepIndex={9}
              lockedAllFields={this.props.lockedAllFields}
              onExtendChanged={this.onChangedExtendedByIndex}
              fieldNames={[this.props.languageValues.descricaoMostraPedagogica]}
              fieldValues={[this.props.projeto.descricaoMostraPedagogica]}
              extended={this.state['etapa' + 9 + 'Extended']}
            />
          </div>
        )}
      </CustomCard>
    );
  }
}

Etapa9.propTypes = {
  loading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
  escolas: state.escolas,
  assessores: state.assessores,
  professores: state.professores,
  allCooperativas: state.logradouro.cooperativas,
  logradouro: state.logradouro,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
      saveProjeto,
      loadEscolas,
      loadAssessoresByCoop,
      loadEducadores,
      loadEtapasEnsino,
      loadPrincipiosValores,
      loadCooperativas,
      alterarCheckCoordenador,
      alterarCheckProfGestor,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Etapa9));
